export default "__VITE_ASSET__Cg$2qYcx__"